import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { DEFAULT_LOCALE } from '../../../../modules/i18n/locales';
import useCurrentSite from '../../../../modules/react/hooks/useCurrentSite';
import useCurrentPage from '../../../hooks/useCurrentPage';
import MediaGalleryImage from '../../../../modules/react/components/stateful/MediaGalleryImage';

const propTypes = {
  className: PropTypes.string,
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

const defaultProps = {
  className: undefined,
  style: undefined,
};

const HeaderLogo = ({
  className,
  style,
}) => {
  const { locale } = useIntl();
  const { publicLogo: fallbackLogo } = useCurrentSite();
  const { publicLogo } = useCurrentPage();
  const { alt, link, medium, title, url } = publicLogo;

  // For all sites, the href for the Header Logo will always be
  // the index of the current locale a user is on.
  const href = locale === DEFAULT_LOCALE ? link.href : `/${locale}`;

  if (medium && medium.id && !medium.trash) {
    return (
      <MediaGalleryImage
        link={href}
        medium={medium}
        className={className}
        legacyImage={{ alt, title, file: url }}
      />
    );
  }

  const {
    alt: fallbackAlt,
    title: fallbackTitle,
    medium: fallbackMedium,
    url: fallbackUrl,
  } = fallbackLogo || {};

  if (fallbackMedium && fallbackMedium.id && !fallbackMedium.trash) {
    return (
      <MediaGalleryImage
        link={href}
        medium={fallbackMedium}
        className={className}
        legacyImage={{ alt: fallbackAlt, title: fallbackTitle, file: fallbackUrl }}
      />
    );
  }

  const image = (
    <img
      alt={alt}
      className={className}
      src={url}
      style={style}
      title={title}
    />
  );

  return (
    <a href={href} target={link.target}>
      {image}
    </a>
  );
};

HeaderLogo.propTypes = propTypes;
HeaderLogo.defaultProps = defaultProps;

export default HeaderLogo;
